import { Middleware, Context } from '@nuxt/types'

const pageBackMiddleware: Middleware = ({ route, from, $tstore }: Context) => {
  if (from && Object.keys(route.query).length === 0) {
    $tstore.pageHistory.setLatestPage(from.path)
  }
}

export default pageBackMiddleware
